export enum ContentTypesEnum {
  // Domain
  Flows = "Flows",
  AllFlows = "All Flows",
  Scheduled = "Scheduled",
  Videos = "Videos",
  Links = "Links",
  Surveys = "Surveys",
  Assessments = "Assessments",
  Events = "Events",
  Emails = "Emails",
  Messages = "Messages",
  PDFs = "PDFs",
  "Embedded Videos" = "Embedded Videos",

  // Abstract
  Assets = "Assets",
  Uploaded = "Uploaded",
  Embedded = "Embedded",
  Campaigns = "Campaigns",
}

export type ContentType =
  | "video"
  | "assessment"
  | "pdf"
  | "survey"
  | "flow"
  | "externalEvent"
  | "embeddedVideo"
  | "link";
